module.exports = __webpack_public_path__ + "img/guzheng2.05f75666.png";